<template>
  <header class="main-menu">
    <div class="container">
      <section class="main-menu__logo">
        <a href="/" class="logo">
        </a>
      </section>
    </div>
  </header>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/menu.scss';
</style>

<script>

export default {
  name: 'menu',
  data() {
  },
  components: {
  },
  methods: {
  },
};
</script>
